import React from "react";
import PropTypes from "prop-types";
import CustomizePageAdd from "./CustomizePageAdd";
import CustomizePagePreview from "./CustomizePagePreview";
import CustomizePageEdit from "./CustomizePageEdit";
import { connect } from "react-redux";

function CustomizeInactivePage({ page, hasSubjectPropertyZipcode }) {
  const isMarketTrend = page.key === "market_trends";
  const disablePage = !hasSubjectPropertyZipcode && isMarketTrend;

  return (
    <div className="customize-inactive-page">
      <CustomizePageAdd isDisabled={disablePage} page={page} />
      <CustomizePagePreview isDisabled={disablePage} page={page} />
      <CustomizePageEdit page={page} />
    </div>
  );
}

CustomizeInactivePage.propTypes = {
  page: PropTypes.object.isRequired,
  hasSubjectPropertyZipcode: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  hasSubjectPropertyZipcode: !!state.subjectProperty?.zip
});

export default connect(mapStateToProps)(CustomizeInactivePage);
